import { type CountryCode, isValidPhoneNumber } from 'libphonenumber-js/max'

import { availableCountryCode } from '@/lib/onboardingCountry'
import { hasNumericalSequence } from '@/lib/validation'

import { hasInternationalPrefix, withPlusPrefix } from './onboardingPhoneNormalize'

export { normalizeOnboardingPhone, ONBOARDING_PHONE_FIELDS } from './onboardingPhoneNormalize'

/**
 * `defaultCountry` (ISO, e.g. `'US'`) lets national-format numbers such as
 * `(305) 555-1234` validate; numbers with a `+`/`00` prefix ignore it.
 */
export function isValidOnboardingPhone(value: unknown, defaultCountry?: string | null): boolean {
  const phone = String(value ?? '').trim()
  if (!phone || hasNumericalSequence(phone)) return false
  const country = (defaultCountry?.toUpperCase() || undefined) as CountryCode | undefined
  return hasInternationalPrefix(phone) || !country
    ? isValidPhoneNumber(withPlusPrefix(phone))
    : isValidPhoneNumber(phone, country)
}

/** ISO country for national-format phone numbers: always `US` for US onboarding, else the form country. */
export function resolveOnboardingPhoneCountry(
  isUsOnboarding: boolean,
  formCountry: unknown,
  translate?: (key: string) => string
): string | null {
  if (isUsOnboarding) return 'US'
  return availableCountryCode(formCountry, translate)?.toUpperCase() || null
}
